
import React from 'react';

const MedicationsHero = () => {
  return (
    <div className="relative bg-gradient-to-b from-blue-50 to-white py-10 md:py-16">
      <div className="container">
        <div className="flex items-center gap-8 mb-4">
          <img 
            src="/lovable-uploads/5b2f7632-fdb2-4b4d-a8fc-2a786daa0e36.png" 
            alt="Grand Ave Pharmacy" 
            className="h-28 md:h-32 w-auto flex-shrink-0"
          />
          <div className="text-left">
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight text-slate-900 mb-4">
              Compounded Medications Guide
            </h1>
            <p className="text-lg md:text-xl text-slate-700 max-w-2xl">
              An educational resource for patients and healthcare providers.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MedicationsHero;
